/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetBrowserSessionUrlRequest = {
  sessionId: string;
  sessionToken?: string | null | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetBrowserSessionUrlRequest$inboundSchema: z.ZodType<
  GetBrowserSessionUrlRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  session_id: z.string(),
  session_token: z.nullable(z.string()).optional(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "session_id": "sessionId",
    "session_token": "sessionToken",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetBrowserSessionUrlRequest$Outbound = {
  session_id: string;
  session_token?: string | null | undefined;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetBrowserSessionUrlRequest$outboundSchema: z.ZodType<
  GetBrowserSessionUrlRequest$Outbound,
  z.ZodTypeDef,
  GetBrowserSessionUrlRequest
> = z.object({
  sessionId: z.string(),
  sessionToken: z.nullable(z.string()).optional(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    sessionId: "session_id",
    sessionToken: "session_token",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getBrowserSessionUrlRequestToJSON(
  getBrowserSessionUrlRequest: GetBrowserSessionUrlRequest,
): string {
  return JSON.stringify(
    GetBrowserSessionUrlRequest$outboundSchema.parse(
      getBrowserSessionUrlRequest,
    ),
  );
}
export function getBrowserSessionUrlRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetBrowserSessionUrlRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetBrowserSessionUrlRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetBrowserSessionUrlRequest' from JSON`,
  );
}
